module.exports = "<mat-sidenav-container>\r\n  <router-outlet></router-outlet>\r\n</mat-sidenav-container>"


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/layouts/auth/auth-layout.component.html
// module id = ../../../../../src/app/layouts/auth/auth-layout.component.html
// module chunks = main